const mfa = {
    totp: 'OTP din aplicația de autentificare',
    webauthn: 'Cheie de acces',
    backup_code: 'Cod de rezervă',
    link_totp_description: 'De exemplu, Google Authenticator etc.',
    link_webauthn_description: 'Conectează dispozitivul sau hardware-ul USB',
    link_backup_code_description: 'Generează un cod de rezervă',
    verify_totp_description: 'Introdu codul unic din aplicație',
    verify_webauthn_description: 'Verifică dispozitivul sau hardware-ul USB',
    verify_backup_code_description: 'Introdu codul de rezervă salvat',
    add_mfa_factors: 'Adaugă verificare în doi pași',
    add_mfa_description: 'Verificarea în doi pași este activată. Selectează a doua metodă de verificare pentru o autentificare sigură.',
    verify_mfa_factors: 'Verificare în doi pași',
    verify_mfa_description: 'Verificarea în doi pași a fost activată pentru acest cont. Te rugăm să selectezi a doua metodă pentru a-ți verifica identitatea.',
    add_authenticator_app: 'Adaugă aplicația de autentificare',
    step: 'Pasul {{step, number}}: {{content}}',
    scan_qr_code: 'Scanează acest cod QR',
    scan_qr_code_description: 'Scanează codul QR de mai jos cu aplicația ta de autentificare, cum ar fi Google Authenticator, Duo Mobile, Authy etc.',
    qr_code_not_available: 'Nu poți scana codul QR?',
    copy_and_paste_key: 'Copiază și lipeste cheia',
    copy_and_paste_key_description: 'Copiază și lipește cheia următoare în aplicația ta de autentificare, cum ar fi Google Authenticator, Duo Mobile, Authy etc.',
    want_to_scan_qr_code: 'Vrei să scanezi codul QR?',
    enter_one_time_code: 'Introdu codul unic',
    enter_one_time_code_link_description: 'Introdu codul de verificare din 6 cifre generat de aplicația de autentificare.',
    enter_one_time_code_description: 'Verificarea în doi pași a fost activată pentru acest cont. Te rugăm să introduci codul unic afișat în aplicația ta de autentificare conectată.',
    link_another_mfa_factor: 'Treci la altă metodă',
    save_backup_code: 'Salvează codul de rezervă',
    save_backup_code_description: 'Poți folosi unul dintre aceste coduri de rezervă pentru a accesa contul tău dacă întâmpini probleme cu verificarea în doi pași prin alte metode. Fiecare cod poate fi utilizat o singură dată.',
    backup_code_hint: 'Asigură-te că le copiezi și le salvezi într-un loc sigur.',
    enter_a_backup_code: 'Introdu un cod de rezervă',
    enter_backup_code_description: 'Introdu codul de rezervă pe care l-ai salvat când verificarea în doi pași a fost activată inițial.',
    create_a_passkey: 'Creează o cheie de acces',
    create_passkey_description: 'Înregistrează cheia de acces utilizând biometria dispozitivului, chei de securitate (ex. YubiKey) sau alte metode disponibile.',
    try_another_verification_method: 'Încearcă o altă metodă de verificare',
    verify_via_passkey: 'Verifică prin cheie de acces',
    verify_via_passkey_description: 'Folosește cheia de acces pentru a te verifica prin parola dispozitivului sau biometrie, scanarea unui cod QR sau utilizarea unei chei de securitate USB precum YubiKey.',
    secret_key_copied: 'Cheia secretă a fost copiată.',
    backup_code_copied: 'Codul de rezervă a fost copiat.',
    webauthn_not_ready: 'WebAuthn nu este încă pregătit. Încearcă din nou mai târziu.',
    webauthn_not_supported: 'WebAuthn nu este suportat în acest browser.',
    webauthn_failed_to_create: 'Crearea a eșuat. Încearcă din nou.',
    webauthn_failed_to_verify: 'Verificarea a eșuat. Încearcă din nou.',
};
export default Object.freeze(mfa);
